var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8627 10.3939L16.25 13.9877C16.0669 14.1707 15.7702 14.1707 15.5871 13.9877L15.3109 13.7115C15.1278 13.5285 15.1278 13.2317 15.3109 13.0486L17.6911 10.6875H0.46875C0.209883 10.6875 0 10.4776 0 10.2187V9.90623C0 9.64736 0.209883 9.43748 0.46875 9.43748H17.6916L15.3109 7.07639C15.1278 6.89334 15.1278 6.59654 15.3109 6.41346L15.5871 6.13729C15.7702 5.95424 16.0669 5.95424 16.25 6.13729L19.8627 9.73104C20.0458 9.91408 20.0457 10.2109 19.8627 10.3939Z",
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIn);
export default __webpack_public_path__ + "static/media/invoice-in.8570f7b210e29ed28f3223166c509360.svg";
export { ForwardRef as ReactComponent };